import script from "./QuickContactWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuickContactWidget.vue?vue&type=script&setup=true&lang=ts"

import "./QuickContactWidget.vue?vue&type=style&index=0&id=1d64275e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d64275e"]])

export default __exports__